<template>
  <v-dialog value="true" persistent width="600px">
    <v-card class="dialog-content pa-6" width="600px" height="500px">
      <h3 class="title pa-0 mb-4 align-self-start">Detalhes do número da sorte</h3>
      <v-col class="pa-0 mb-0">
        <v-col v-for="(field, index) in fields" :key="index" cols="12" class="py-2 px-4">
          <v-row>
            <v-col cols="6" class="pa-0 field-title">
              <p>{{ field.title }}</p>
            </v-col>
            <v-col cols="6" class="pa-0">
              <p>{{ field.text }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
      <mf-action-buttons
        class="py-2"
        :primary-button="{
          text: 'Fechar',
          action: () => $emit('close'),
          isVisible: true,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ParticipantDetails',
  props: {
    raffleParticipant: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    fields: [],
  }),
  mounted() {
    if (this.raffleParticipant) {
      this.fields = [
        {
          title: 'Consumidor:',
          text: this.raffleParticipant.user.name,
        },
        {
          title: 'CPF/CNPJ:',
          text: this.$options.filters.cpfCnpj(this.raffleParticipant.user.document_no),
        },
        {
          title: 'Número da sorte:',
          text: this.raffleParticipant.lucky_number.number,
        },
        {
          title: 'ID do usuário:',
          text: this.raffleParticipant.user._id,
        },
        {
          title: 'Data de aquisição do número:',
          text: moment(this.raffleParticipant.lucky_number.created_at).format('DD/MM/YYYY'),
        },
        {
          title: 'Data da venda de aquisição do número:',
          text: moment(this.raffleParticipant.lucky_number.coupon_created_at).format('DD/MM/YYYY'),
        },
        {
          title: 'Loja:',
          text: this.raffleParticipant.lucky_number.unit.name,
        },
        {
          title: 'Valor do cupom:',
          text: this.$options.filters.currency(this.raffleParticipant.lucky_number.coupon_value).replace('.', ','),
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 5px;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
}
.field-title {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.4px;
  color: $cinza-0;
}
</style>
